import { createGlobalStore } from 'hox';
import { useState } from 'react';

const useDashboardExpand = () => {
  const [sectionsExpanded, setSectionsExpanded] = useState<
    Record<string, boolean>
  >(() => {
    const expanded = localStorage.getItem('casDashboardSectionsExpanded');
    return expanded ? JSON.parse(expanded) : {};
  });

  const handleExpandChange = (key: string, expanded: boolean) => {
    const newSectionsExpanded = { ...sectionsExpanded, [key]: expanded };
    setSectionsExpanded(newSectionsExpanded);
    localStorage.setItem(
      'casDashboardSectionsExpanded',
      JSON.stringify(newSectionsExpanded)
    );
  };

  return { sectionsExpanded, handleExpandChange };
};

export const [useDashboardExpandStore] = createGlobalStore(useDashboardExpand);
